'use client'

import { useMemo } from 'react'
import { capitalize } from 'lodash'
import { NavLink } from 'react-router'
import { Box, Button, Card, CardContent, CardMedia, Skeleton, Stack } from '@mui/material'
import { getMediaObjectKey } from '@wolfdanepug/media-service-nextjs'
import { PawSolid } from '@wolfdanepug/icons'
import { Logger, Typography } from '@wolfdanepug/common-react'
import { getNoImage, getProfileColor } from '../../utils'
import { mediaPath } from '../../constants'

const ageDisplayMap: Record<string, string> = {
	years: 'yo.',
	months: 'mo.',
	weeks: 'wk.'
}

export default function PetProfileCard({ item, loading = false, index }: any) {
	const profileColor = getProfileColor(index)

	const profile = useMemo(() => {
		return item?.profile
	}, [item?.profile])

	const image = useMemo(() => {
		Logger.log(profile)
		if (!profile?.image) {
			return getNoImage(index)
		}
		return `${mediaPath}/${getMediaObjectKey(profile.image)}`
	}, [index, profile])

	return (
		<Card sx={{ position: 'relative', borderRadius: 3 }} elevation={3}>
			<CardMedia image={image} component="img" sx={{ borderBottom: `8px solid ${profileColor}` }} />
			<CardContent>
				<Box
					sx={{
						display: 'flex',
						position: 'absolute',
						top: 24,
						right: 24,
						zIndex: 5,
						backgroundColor: profileColor,
						borderRadius: '50%',
						width: 60,
						height: 60,
						justifyContent: 'center',
						alignItems: 'center',
						border: '3px solid #fff'
					}}
				>
					<PawSolid />
				</Box>
				<Stack gap={3}>
					<Stack>
						<Typography variant="h6" sx={{ fontSize: 24 }}>
							{profile?.name}
						</Typography>
						<Typography variant="body1">
							{profile?.age} {ageDisplayMap[profile?.ageContext]} old {capitalize(profile?.gender)}{' '}
							({profile?.weight} lbs.)
						</Typography>

						{profile?.breed && (
							<Typography loading={loading} textAlign="center">
								{profile?.breed.map((b: any) => b.title).join(', ')}
							</Typography>
						)}
					</Stack>

					{profile ? (
						<Button
							component={NavLink}
							variant="contained"
							to={`/pets/${profile?.id}/info`}
							size="small"
							sx={{ alignSelf: 'flex-start' }}
						>
							View Profile
						</Button>
					) : (
						<Skeleton variant="rectangular" height={40} />
					)}
				</Stack>
			</CardContent>
		</Card>
	)
}
